@import "../../common/base";

@include button-reset();
@include box-sizing();

:host {
  /**
   * @prop --ch-action-menu-item__image-size:
   * Specifies the box size that contains the start or end images of the items.
   * @default #{$default-decorative-image-size}
   */
  --ch-action-menu-item__image-size: #{$default-decorative-image-size};

  /**
   * @prop --ch-action-menu-item__background-image-size:
   * Specifies the size of the start and end images of the items.
   * @default 100%
   */
  --ch-action-menu-item__background-image-size: 100%;

  --ch-action-menu-separation: 0px;
  --ch-action-menu-separation-x: var(--ch-action-menu-separation);
  --ch-action-menu-separation-y: var(--ch-action-menu-separation);

  display: contents;
}

::slotted(action) {
  pointer-events: none;
}

hr {
  display: grid;
  block-size: 1px;
  margin: 0;
  background-color: color-mix(in srgb, currentColor 25%, transparent);
  border: unset;
  pointer-events: none;
}
